import React from 'react'
import { Clear, Crop } from '@mui/icons-material'

import CropImage from '../../../CropImage'

import { useCustomerContext } from '../../../../../providers/CustomerProvider'
import { useAreYouSure } from '../../../../../providers/AreYouSureProvider'
import useStyles from './styles'
import { Camera } from 'iconsax-react'

const NameSection = () => {
  const { values, handleChange, setAvatarFile } = useCustomerContext()
  const { setAction, setReason, setSubtext, setTitle, setV2 } = useAreYouSure()

  const [uploadImg, setUploadImg] = React.useState(null)
  const [originalImg, setOriginalImg] = React.useState(null)
  const [cropping, setCropping] = React.useState(false)

  const classes = useStyles()

  const handleImgUpload = e => {
    const file = e.target.files[0]
    // setting img to upload
    setAvatarFile(file)
    // upload image to avatar area
    const url = URL.createObjectURL(file)
    setUploadImg(url)
    setOriginalImg(url)
  }

  const ClearIcon = (
    <Clear
      onClick={e => {
        e.preventDefault()
        e.stopPropagation()

        setAction(() => {
          setAvatarFile(null)
          setUploadImg(null)
          setOriginalImg(null)
        })
        setReason('Are you sure you want to remove this avatar?')
        setSubtext('')
        setTitle('ARE YOU SURE?')
        setV2(true)
      }}
      className={classes.clearIcon}
    />
  )

  return (
    <>
      <div className={classes.name}>
        <div>
          <label className={classes.label}>
            {uploadImg ? (
              <>
                <div
                  className={classes.avatar}
                  style={{ backgroundImage: `url(${uploadImg})` }}
                />

                {ClearIcon}

                <Crop
                  onClick={e => {
                    e.preventDefault()
                    e.stopPropagation()
                    setCropping(true)
                  }}
                  className={classes.cropIcon}
                />

                {cropping && (
                  <CropImage
                    imgSrc={originalImg}
                    onClose={() => setCropping(false)}
                    onCrop={file => {
                      setUploadImg(URL.createObjectURL(file))
                      setAvatarFile(file)
                    }}
                  />
                )}
              </>
            ) : (
              <Camera className={classes.camera} />
            )}

            <input type='file' hidden onChange={e => handleImgUpload(e)} />
          </label>
        </div>

        <input
          placeholder='Enter Contact Name'
          className={classes.input}
          value={values.name ?? ''}
          onChange={e => handleChange(e.target.value, 'name')}
        />
      </div>
    </>
  )
}

export default NameSection
